export const migrations = {
  14: (state: any) => {
    const newState = { ...state };

    delete newState.dataGridOrderReducer;
    delete newState.dataGridColumnVisibilityModelReducer;
    delete newState.dataGridColumnWidthsReducer;
    delete newState.dataGridRowsForPageReducer;

    return newState;
  },
};
